<ng-template #accordion let-accordion="accordionItem">
  <ng-container [ngTemplateOutlet]="(header?.templateRef || null)" [ngTemplateOutletContext]="{ accordion: accordion }"></ng-container>

  <ng-container *ngIf="content?.expanded">
    <ng-container [ngTemplateOutlet]="content?.templateRef || null" [ngTemplateOutletContext]="{ accordion: accordion }"></ng-container>
  </ng-container>
</ng-template>
